import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

export const getQRCode = createAsyncThunk('verify2FA/getQRCode', async () => {
	return await AccountService.getQRCode();
});
